import { initialEntities as formRendererEntities } from 'common/compounds/FormRenderer/reducers';

import createEntitiesReducer from 'common/entities/createEntitiesReducer';
import { ENTITIES_KEY_TICKET_TYPES } from 'common/entities/ticketType';

const INITIAL_STATE = {
    ...formRendererEntities,
    [ENTITIES_KEY_TICKET_TYPES]: {},
};

export default createEntitiesReducer(INITIAL_STATE);
